<h3>Contracts</h3>
<p-toolbar>
  <div class="p-toolbar-group-start">
    <p-button label="Form Inputs"
              class="p-button-primary mr-2"
              (onClick)="onFormInputsClick()">
    </p-button>
  </div>
</p-toolbar>
